import { jsonGet } from "@quortex/front-common"
import type { QueryFunctionContext } from "@tanstack/react-query"

interface Release {
  build: {
    date: string
    id?: string
  }
}

export const useRelease = () => {
  const url = "/release.json"

  return {
    queryFn: ({ signal }: QueryFunctionContext) => jsonGet<Release>(url, "", "www", { signal }),
    queryKey: ["release"]
  }
}
